import { useFormContext, useWatch } from 'react-hook-form';

import { DateFieldRhf } from '@xemplo/date-field';

import { FormFields } from '../../../create-amendment.types';
import * as S from '../../modal.styles';

import { RecurringTypeValues } from './recurring-type';

export function RecurringEndDate() {
  const { control } = useFormContext<FormFields>();
  const recurringType = useWatch({ control, name: 'recurringType' });
  const showEndDate = recurringType === RecurringTypeValues.END_DATE;

  if (!showEndDate) return null;

  return (
    <S.FormLabel>
      End date
      <DateFieldRhf
        name="recurringEndDate"
        aria-label="Recurring end date"
        placeholder="Select end date"
        rules={{ required: 'This field is required' }}
      />
    </S.FormLabel>
  );
}
